module.exports = __webpack_public_path__ + "img/step-done-medal.f9f93863.png";